<template>
  <div class="container-fluid">
    <Brand/>
    <Nav/>
    <router-view/>
    <Footer/>
  </div>
</template>

<script>
import Brand from '@/components/Brand';
import Footer from '@/components/Footer';
import Nav from '@/components/Nav';

export default {
  name: 'App',
  components: {
    Brand,
    Footer,
    Nav,
  },
};
</script>

<style>
.container-fluid{
  padding: .5rem 3rem 0rem 3rem;
}
h2, p{
  color:#404040;
  text-shadow: -1px -1px 0 rgba(0,0,0,0);
}
.important{
  text-decoration: underline;
  font-weight: bold;
}
h2{
  padding-left: 3rem;
}
p{
  font-size: 1.1rem;
}
.person{
  padding-left: 5rem;
  padding-top: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue